import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators'
import { projectConstants } from '../shared/constants/project-constants';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
  constructor(private router: Router) { }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    // handle your auth error or rethrow
    if (err.status === 419) {
      // alert("routerurl"+this.router.url);
      const userType = localStorage.getItem('userType');
      if (userType === 'Support' || this.router.url === '/login/support') {
        // navigate /delete cookies or whatever
        this.router.navigateByUrl(`/login/support`);
      } else {
        this.router.navigateByUrl(`/login`);
      }
      return throwError(err);
    }
    return throwError(err);
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    console.log(request);

    if (request.url.substr(0, 4) === 'http') {
      return next.handle(request);
    }


    return next.handle(this.updateHeader(request)).pipe(
      catchError((error) => {
        return this.handleAuthError(error);
      })
    )
  }

  updateHeader(request) {
    request = request.clone({ headers: request.headers.set('Accept', 'application/json'), withCredentials: true });
    request = request.clone({ headers: request.headers.append('Cache-Control', 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0'), withCredentials: true });
    request = request.clone({ headers: request.headers.append('Pragma', 'no-cache'), withCredentials: true });
    request = request.clone({ headers: request.headers.append('SameSite', 'None'), withCredentials: true });
    request = request.clone({ headers: request.headers.append('Expires', '0'), withCredentials: true });
    request = request.clone({ url: projectConstants.BASE_URL + request.url, responseType: 'json' });
    console.log(request);
    return request;
  }
}
